// src/api/permiso.js - API para manejo de permisos
import { apiFetch } from './index.js';

export const obtenerPermisos = async () => {
  try {
    console.log('🔑 Obteniendo permisos...');
    const response = await apiFetch('/Permiso');
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Permisos obtenidos exitosamente'
    };
  } catch (error) {
    console.error('❌ Error obteniendo permisos:', error);
    return { success: false, error: error.message, data: [], count: 0 };
  }
};

export const obtenerPermisoPorId = async (id) => {
  try {
    if (!id) throw new Error('ID de permiso es requerido');
    console.log(`🔍 Obteniendo permiso ID: ${id}`);
    const response = await apiFetch(`/Permiso/${id}`);
    return { success: true, data: response, message: 'Permiso obtenido exitosamente' };
  } catch (error) {
    console.error(`❌ Error obteniendo permiso ${id}:`, error);
    return { success: false, error: error.message, data: null };
  }
};

export const obtenerPermisoConModulo = async (id) => {
  try {
    if (!id) throw new Error('ID de permiso es requerido');
    console.log(`🔍 Obteniendo permiso con módulo ID: ${id}`);
    const response = await apiFetch(`/Permiso/${id}/con-modulo`);
    return { success: true, data: response, message: 'Permiso con módulo obtenido exitosamente' };
  } catch (error) {
    console.error(`❌ Error obteniendo permiso con módulo ${id}:`, error);
    return { success: false, error: error.message, data: null };
  }
};

export const obtenerEstadisticasPermiso = async (id) => {
  try {
    if (!id) throw new Error('ID de permiso es requerido');
    console.log(`📊 Obteniendo estadísticas permiso ID: ${id}`);
    const response = await apiFetch(`/Permiso/${id}/estadisticas`);
    return { success: true, data: response, message: 'Estadísticas obtenidas exitosamente' };
  } catch (error) {
    console.error(`❌ Error obteniendo estadísticas permiso ${id}:`, error);
    return { success: false, error: error.message, data: null };
  }
};

export const obtenerRolesConPermiso = async (id) => {
  try {
    if (!id) throw new Error('ID de permiso es requerido');
    console.log(`👥 Obteniendo roles con permiso ID: ${id}`);
    const response = await apiFetch(`/Permiso/${id}/asignado-roles`);
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Roles obtenidos exitosamente'
    };
  } catch (error) {
    console.error(`❌ Error obteniendo roles con permiso ${id}:`, error);
    return { success: false, error: error.message, data: [], count: 0 };
  }
};

export const verificarPermisoExiste = async (id) => {
  try {
    if (!id) throw new Error('ID es requerido');
    console.log(`🔎 Verificando si permiso ID ${id} existe`);
    const response = await apiFetch(`/Permiso/${id}/exists`);
    const existe = typeof response === 'boolean' ? response : response.existe || false;
    return {
      success: true,
      existe: existe,
      message: existe ? 'El permiso existe' : 'El permiso no existe'
    };
  } catch (error) {
    console.error(`❌ Error verificando permiso ${id}:`, error);
    return { success: false, error: error.message, existe: false };
  }
};

export const verificarNombrePermiso = async (nombre) => {
  try {
    if (!nombre || nombre.trim() === '') throw new Error('Nombre es requerido');
    console.log(`🔎 Verificando nombre de permiso: "${nombre}"`);
    const response = await apiFetch(`/Permiso/validar-nombre?nombre=${encodeURIComponent(nombre)}`);
    const existe = typeof response === 'boolean' ? response : response.existe || false;
    return {
      success: true,
      existe: existe,
      disponible: !existe,
      message: existe ? 'El nombre ya existe' : 'Nombre disponible'
    };
  } catch (error) {
    console.error(`❌ Error verificando nombre "${nombre}":`, error);
    return { success: false, error: error.message, existe: false, disponible: false };
  }
};

export const obtenerAccionesComunes = async () => {
  try {
    console.log('📋 Obteniendo acciones comunes...');
    const response = await apiFetch('/Permiso/acciones-comunes');
    return { success: true, data: response, message: 'Acciones comunes obtenidas exitosamente' };
  } catch (error) {
    console.error('❌ Error obteniendo acciones comunes:', error);
    return { success: false, error: error.message, data: [] };
  }
};

export const obtenerPermisosPorModulo = async (idModulo) => {
  try {
    if (!idModulo) throw new Error('ID de módulo es requerido');
    console.log(`🔍 Obteniendo permisos del módulo ID: ${idModulo}`);
    const response = await apiFetch(`/Permiso/modulo/${idModulo}`);
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Permisos por módulo obtenidos exitosamente'
    };
  } catch (error) {
    console.error(`❌ Error obteniendo permisos por módulo ${idModulo}:`, error);
    return { success: false, error: error.message, data: [], count: 0 };
  }
};

export const obtenerPermisosPorRol = async (idRol) => {
  try {
    if (!idRol) throw new Error('ID de rol es requerido');
    console.log(`🔍 Obteniendo permisos del rol ID: ${idRol}`);
    const response = await apiFetch(`/Permiso/rol/${idRol}`);
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Permisos por rol obtenidos exitosamente'
    };
  } catch (error) {
    console.error(`❌ Error obteniendo permisos por rol ${idRol}:`, error);
    return { success: false, error: error.message, data: [], count: 0 };
  }
};

export const obtenerPermisosNoAsignadosARol = async (idRol) => {
  try {
    if (!idRol) throw new Error('ID de rol es requerido');
    console.log(`🔍 Obteniendo permisos no asignados al rol ID: ${idRol}`);
    const response = await apiFetch(`/Permiso/rol/${idRol}/no-asignados`);
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Permisos no asignados obtenidos exitosamente'
    };
  } catch (error) {
    console.error(`❌ Error obteniendo permisos no asignados al rol ${idRol}:`, error);
    return { success: false, error: error.message, data: [], count: 0 };
  }
};

export const obtenerPermisosPorRolConEstado = async (idRol) => {
  try {
    if (!idRol) throw new Error('ID de rol es requerido');
    console.log(`🔍 Obteniendo permisos con estado del rol ID: ${idRol}`);
    const response = await apiFetch(`/Permiso/rol/${idRol}/con-estado`);
    return {
      success: true,
      data: response,
      count: Array.isArray(response) ? response.length : 0,
      message: 'Permisos con estado obtenidos exitosamente'
    };
  } catch (error) {
    console.error(`❌ Error obteniendo permisos con estado del rol ${idRol}:`, error);
    return { success: false, error: error.message, data: [], count: 0 };
  }
};

export const crearPermiso = async (permisoData) => {
  try {
    const requiredFields = ['idModulo', 'nombre_accion'];
    const missingFields = requiredFields.filter(field => !permisoData[field]);
    if (missingFields.length > 0) {
      throw new Error(`Campos requeridos faltantes: ${missingFields.join(', ')}`);
    }
    console.log('➕ Creando nuevo permiso:', permisoData);
    const response = await apiFetch('/Permiso', {
      method: 'POST',
      body: JSON.stringify({
        idModulo: permisoData.idModulo,
        nombre_accion: permisoData.nombre_accion.trim(),
        descripcion: permisoData.descripcion || ''
      })
    });
    return { success: true, data: response, message: 'Permiso creado exitosamente' };
  } catch (error) {
    console.error('❌ Error creando permiso:', error);
    return { success: false, error: error.message, data: null };
  }
};

export const actualizarPermiso = async (id, permisoData) => {
  try {
    if (!id) throw new Error('ID de permiso es requerido');
    console.log(`✏️ Actualizando permiso ID: ${id}`, permisoData);
    const response = await apiFetch(`/Permiso/${id}`, {
      method: 'PUT',
      body: JSON.stringify({
        idModulo: permisoData.idModulo,
        nombre_accion: permisoData.nombre_accion?.trim(),
        descripcion: permisoData.descripcion || ''
      })
    });
    return { success: true, data: response, message: 'Permiso actualizado exitosamente' };
  } catch (error) {
    console.error(`❌ Error actualizando permiso ${id}:`, error);
    return { success: false, error: error.message, data: null };
  }
};

export const eliminarPermiso = async (id) => {
  try {
    if (!id) throw new Error('ID de permiso es requerido');
    console.log(`🗑️ Eliminando permiso ID: ${id}`);
    const response = await apiFetch(`/Permiso/${id}`, { method: 'DELETE' });
    return { success: true, data: response, message: 'Permiso eliminado exitosamente' };
  } catch (error) {
    console.error(`❌ Error eliminando permiso ${id}:`, error);
    return { success: false, error: error.message, data: null };
  }
};

export const asignarPermisoARol = async (data) => {
  try {
    const { idPermiso, idRol } = data;
    if (!idPermiso || !idRol) throw new Error('ID de permiso y ID de rol son requeridos');
    console.log(`🔗 Asignando permiso ID: ${idPermiso} a rol ID: ${idRol}`);
    const response = await apiFetch('/Permiso/asignar-a-rol', {
      method: 'POST',
      body: JSON.stringify({ idPermiso, idRol })
    });
    return { success: true, data: response, message: 'Permiso asignado exitosamente' };
  } catch (error) {
    console.error(`❌ Error asignando permiso a rol:`, error);
    return { success: false, error: error.message, data: null };
  }
};

export const quitarPermisoDeRol = async (data) => {
  try {
    const { idPermiso, idRol } = data;
    if (!idPermiso || !idRol) throw new Error('ID de permiso y ID de rol son requeridos');
    console.log(`🔗 Quitando permiso ID: ${idPermiso} del rol ID: ${idRol}`);
    const response = await apiFetch(`/Permiso/${idPermiso}/rol/${idRol}`, {
      method: 'DELETE'
    });
    return { success: true, data: response, message: 'Permiso quitado exitosamente' };
  } catch (error) {
    console.error(`❌ Error quitando permiso de rol:`, error);
    return { success: false, error: error.message, data: null };
  }
};

// ==================== FUNCIONES AUXILIARES ====================

export const formatearFechaPermiso = (fechaISO, completo = false) => {
  if (!fechaISO) return 'N/A';
  try {
    const fecha = new Date(fechaISO);
    const opciones = { year: 'numeric', month: 'short', day: 'numeric' };
    if (completo) { opciones.hour = '2-digit'; opciones.minute = '2-digit'; }
    return fecha.toLocaleDateString('es-ES', opciones);
  } catch (error) {
    return fechaISO;
  }
};

export const buscarPermisos = (permisos, termino) => {
  if (!termino || termino.trim() === '') return permisos;
  const terminoLower = termino.toLowerCase();
  return permisos.filter(permiso =>
    permiso.nombre_accion?.toLowerCase().includes(terminoLower) ||
    permiso.descripcion?.toLowerCase().includes(terminoLower) ||
    permiso.modulo_nombre?.toLowerCase().includes(terminoLower)
  );
};

export const agruparPermisosPorModulo = (permisos) => {
  return permisos.reduce((acc, permiso) => {
    const modulo = permiso.modulo_nombre || permiso.idModulo || 'Sin módulo';
    if (!acc[modulo]) acc[modulo] = [];
    acc[modulo].push(permiso);
    return acc;
  }, {});
};

export const obtenerAccionesPorModulo = (modulos) => {
  const acciones = {
    'dashboard': ['ver', 'exportar', 'configurar'],
    'servicios': ['ver', 'crear', 'editar', 'eliminar'],
    'ordenes': ['ver', 'crear', 'editar', 'eliminar', 'cambiar_estado'],
    'productos': ['ver', 'crear', 'editar', 'eliminar', 'ajustar_stock'],
    'ventas': ['ver', 'crear', 'anular', 'exportar'],
    'clientes': ['ver', 'crear', 'editar', 'eliminar'],
    'usuarios': ['ver', 'crear', 'editar', 'eliminar', 'cambiar_estado'],
    'roles': ['ver', 'crear', 'editar', 'eliminar', 'asignar_permisos']
  };
  return modulos.reduce((acc, modulo) => {
    const nombreModulo = modulo.nombre?.toLowerCase() || '';
    acc[modulo.idModulo] = {
      modulo: modulo,
      acciones: acciones[nombreModulo] || ['ver', 'crear', 'editar', 'eliminar']
    };
    return acc;
  }, {});
};

export const formatearNombreAccion = (nombreAccion) => {
  if (!nombreAccion) return '';
  return nombreAccion
    .split('_')
    .map(palabra => palabra.charAt(0).toUpperCase() + palabra.slice(1))
    .join(' ');
};

export const obtenerIconoPorAccion = (accion) => {
  const iconos = {
    'ver': 'mdi:eye-outline',
    'crear': 'mdi:plus-circle-outline',
    'editar': 'mdi:pencil-outline',
    'eliminar': 'mdi:trash-outline',
    'exportar': 'mdi:export',
    'importar': 'mdi:import',
    'cambiar_estado': 'mdi:swap-horizontal',
    'asignar': 'mdi:account-plus-outline',
    'configurar': 'mdi:cog-outline'
  };
  return iconos[accion] || 'mdi:lock-outline';
};

// ==================== EXPORT DEFAULT ====================

export default {
  obtenerPermisos,
  obtenerPermisoPorId,
  obtenerPermisoConModulo,
  obtenerEstadisticasPermiso,
  obtenerRolesConPermiso,
  verificarPermisoExiste,
  verificarNombrePermiso,
  obtenerAccionesComunes,
  obtenerPermisosPorModulo,
  obtenerPermisosPorRol,
  obtenerPermisosNoAsignadosARol,
  obtenerPermisosPorRolConEstado,
  crearPermiso,
  actualizarPermiso,
  eliminarPermiso,
  asignarPermisoARol,
  quitarPermisoDeRol,
  formatearFechaPermiso,
  buscarPermisos,
  agruparPermisosPorModulo,
  obtenerAccionesPorModulo,
  formatearNombreAccion,
  obtenerIconoPorAccion
};